import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ServiceaftaleDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceaftale-dto';
import { UpcomingChangesDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/upcoming-changes-dto';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-upcoming-changes',
    templateUrl: './upcoming-changes.component.html',
    styleUrls: ['./upcoming-changes.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UpcomingChangesComponent implements OnInit {
  @Input() serviceaftale: ServiceaftaleDto;
  @Input() upcomingChanges: UpcomingChangesDto;
  @Input() showAbonnementAndTilvalgChanges: boolean = true;
  @Input() showPartnerChanges: boolean = true;

  @Output() onRemoveAbonnementChanges: EventEmitter<void> = new EventEmitter();
  @Output() onRemovePartnerChanges: EventEmitter<void> = new EventEmitter();

  showRemoveAbonnementChangesButton = false;
  showRemovePartnerChangesButton = false;

  canRemove: boolean = false;

  constructor(private auth: AuthService) {
    this.canRemove = this.auth.isAdministrator || this.auth.isSuperuser;
  }

  ngOnInit(): void {
    this.showRemoveAbonnementChangesButton = this.hasSubscribers(this.onRemoveAbonnementChanges);
    this.showRemovePartnerChangesButton = this.hasSubscribers(this.onRemovePartnerChanges);
  }

  private hasSubscribers(output: EventEmitter<void>): boolean {
    const emitter = output as unknown as { observers?: unknown[]; observed?: boolean };
    return emitter.observed ?? (emitter.observers?.length ?? 0) > 0;
  }

  removeAbonnementChanges() {
    this.onRemoveAbonnementChanges.emit();
  }
  removePartnerChanges() {
    this.onRemovePartnerChanges.emit();
  }
}
